// Batch 3 M365 strings, merged into gavion.integrations next to batch 6 (see en.ts).
export const integrationsM365En = {
  microsoft: {
    title: "Microsoft 365",
    description: "Outlook mail, calendar and Teams meetings from your mailbox.",
    connect: "Connect",
    reconnect: "Reconnect Microsoft 365",
    disconnect: "Disconnect",
    confirm_disconnect_title: "Disconnect Microsoft 365?",
    confirm_disconnect_body: "Sync stops. Emails already saved are kept.",
    connected_as: "Connected: %{email}",
    last_sync: "Last sync: %{at}",
    never_synced: "Never synced",
    status: {
      connected: "Connected",
      needs_reauth: "Reconnection required",
      error: "Error",
      disconnected: "Disconnected",
      none: "Not connected",
    },
    needs_reauth_help:
      "Your Microsoft authorization expired or was revoked. Reconnect to resume syncing.",
    missing_title: "Unavailable features",
    features: {
      mail_sync: "Email sync",
      send: "Sending email",
      calendar: "Outlook calendar",
      teams_meetings: "Teams meetings",
      archive: "Shared mailbox archive",
    },
    ask_admin: "Ask the administrator to approve the permissions",
    connected_toast: "Microsoft 365 is connected.",
    disconnected_toast: "Microsoft 365 is disconnected.",
  },
  signature: {
    title: "Email signature",
    hint: "Added automatically to emails sent from the CRM. The « Image » button adds your logo.",
    save: "Save signature",
    saved: "Signature saved.",
    add_booking: "Add my meeting link",
    booking_label: "Book a meeting",
  },
  teams: {
    title: "Microsoft Teams",
    description:
      "Channel where notifications are posted (demos, wins, daily digest).",
    team: "Team",
    channel: "Channel",
    choose_team: "Choose a team",
    choose_channel: "Choose a channel",
    save: "Save",
    saved: "Teams channel saved.",
    current: "Posting to %{team} › %{channel}",
    not_configured: "No channel configured.",
    poster_hint: "Messages are posted with your Microsoft account.",
    connect_first: "Connect your Microsoft 365 account first.",
    webhook: "Workflows flow URL (fallback)",
    webhook_hint: "Used if direct posting is refused (403).",
    webhook_save: "Save URL",
    webhook_clear: "Remove URL",
    webhook_saved: "Fallback URL saved.",
    webhook_cleared: "Fallback URL removed.",
    webhook_clear_title: "Remove the fallback URL?",
    webhook_clear_body:
      "If direct posting is refused, no message will be sent.",
    webhook_configured: "Fallback URL configured",
    admin_only: "Administrators only.",
  },
  errors: {
    forbidden: "Access denied.",
    unauthorized: "Session expired. Sign in again.",
    invalid_body: "Invalid request.",
    microsoft_not_connected: "Microsoft 365 is not connected.",
    microsoft_needs_reauth: "Reconnect Microsoft 365.",
    microsoft_account_mismatch:
      "This Microsoft account does not match your Gavion address.",
    microsoft_token_invalid: "Microsoft token rejected. Reconnect.",
    microsoft_app_credentials:
      "The CRM's Microsoft app is misconfigured. Tell the administrator.",
    refresh_token_missing:
      "Microsoft did not grant offline access. Use “Connect”.",
    invalid_state: "The connection expired. Start again.",
    consent_denied: "Authorization refused in Microsoft.",
    suppressed: "Unsubscribed / do not contact: %{emails}",
    no_consent: "No consent for this recipient.",
    // GAVION video-campaign: a campaign follow-up (CASL footer and unsubscribe link)
    campaign_single_recipient:
      "A campaign follow-up goes to one recipient, without cc (its unsubscribe link is their own).",
    unsubscribe_not_configured:
      "The unsubscribe link is not configured. Tell the administrator.",
    attachments_too_large: "Attachments too large",
    graph_throttled: "Try again in a moment.",
    graph_unavailable: "Microsoft is not responding. Try again in a moment.",
    idempotency_conflict: "Send already used by another account.",
    send_in_progress: "Send already in progress…",
    deal_not_found: "Deal not found.",
    no_owner: "This deal has no owner.",
    no_active_demo: "No Outlook demo to change.",
    demo_start_invalid: "Invalid date or duration.",
    demo_in_past: "The demo is in the past.",
    webhook_url_invalid: "URL refused: use the Teams Workflows flow URL.",
    message_gone: "This message no longer exists in Outlook.",
    attachment_unavailable: "This attachment is no longer available.", // GAVION full-email
    not_found: "Not found.",
    m365_unavailable: "Microsoft 365 is not available yet.",
    m365_not_configured:
      "Microsoft 365 has not been set up by the administrator yet.",
    microsoft_consent_missing:
      "Microsoft permissions are missing. Ask the administrator to approve them, then reconnect.",
    graph_send_unknown:
      "The send could not be confirmed. Check your Sent Items in Outlook before retrying.",
    needs_review: "Send needs review: check your Sent Items in Outlook.",
    connect_failed: "The connection failed.",
    unknown: "Something went wrong.",
  },
};
